import { ASSETS, COMPANY } from "@/data/site";

export default function UberUns() {
  return (
    <section id="ueber-uns" data-testid="about-section" className="relative py-24 md:py-32 bg-ink-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Über uns</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
              Saubere Räume.<br />
              <span className="italic text-gold-soft">Klare Haltung.</span>
            </h2>

            <div className="mt-8 space-y-5 text-zinc-300 leading-relaxed">
              <p>
                Five Star Reinigung steht für einen einfachen Anspruch: jede Fläche so behandeln,
                als wäre sie unsere eigene. Wir kombinieren handwerkliche Sorgfalt mit modernen
                Reinigungsverfahren — und einem persönlichen Service, der heute selten geworden ist.
              </p>
              <p>
                Unser Sitz liegt in Ludwigshafen am Rhein. Schwerpunkt unserer Tätigkeit ist
                Baden-Württemberg — bei größeren Projekten betreuen wir Kunden deutschlandweit.
                Vom kleinen Praxisobjekt bis zur Industriehalle planen wir jeden Auftrag individuell.
              </p>
              <p>
                Geschäftsführer Wallat Ramo ist Ihr persönlicher Ansprechpartner. Sie haben eine
                Frage, einen Termin oder einen kurzfristigen Auftrag? Sie erreichen uns direkt —
                ohne Umwege.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
              <div className="border-l border-gold/60 pl-4">
                <div className="font-display text-3xl text-gold">5★</div>
                <div className="text-xs text-zinc-400 mt-1 uppercase tracking-wider">Anspruch</div>
              </div>
              <div className="border-l border-gold/60 pl-4">
                <div className="font-display text-3xl text-gold">24h</div>
                <div className="text-xs text-zinc-400 mt-1 uppercase tracking-wider">Antwortzeit</div>
              </div>
              <div className="border-l border-gold/60 pl-4">
                <div className="font-display text-3xl text-gold">BW</div>
                <div className="text-xs text-zinc-400 mt-1 uppercase tracking-wider">Schwerpunkt</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative">
              <div className="absolute -top-4 -left-4 right-4 bottom-4 border border-gold/40" />
              <img
                src={ASSETS.about}
                alt="Modernes Gebäude bei Nacht"
                className="relative w-full h-[500px] md:h-[600px] object-cover"
              />
              <div className="absolute bottom-6 left-6 right-6 bg-ink-900/80 backdrop-blur-md border border-ink-500/60 p-5">
                <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">Standort</p>
                <p className="text-white font-display text-lg">{COMPANY.address.city}</p>
                <p className="text-sm text-zinc-400">{COMPANY.address.street} · {COMPANY.address.zip}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
